import type {AxiosResponse} from 'axios';

export type PingConfig = {
  name: string;
  url: string;
  expectedResponse?: {
    status: number;
    bodyValidator?: (data: any) => boolean;
  };
};

export const pingConfigs: Record<string, PingConfig> = {
  api: {
    name: 'API ',
    url: 'https://api.autocut.fr/',
    expectedResponse: {
      status: 200,
      bodyValidator: (
        data: AxiosResponse<{alive: boolean; service: string}>['data'],
      ) => {
        return data.alive && data.service === 'autocut-api';
      },
    },
  },
  computeTatinCom: {
    name: 'Compute #1',
    url: 'https://compute.tatin.autocut.com/main.cjs',
    expectedResponse: {
      status: 200,
    },
  },
  computeTatinIo: {
    name: 'Compute #2',
    url: 'https://compute.tatin.autocut.io/main.cjs',
    expectedResponse: {
      status: 200,
    },
  },
  computeCookieCom: {
    name: 'Compute #3',
    url: 'https://compute.cookie.autocut.com/main.cjs',
    expectedResponse: {
      status: 200,
    },
  },
  computeCookieIo: {
    name: 'Compute #4',
    url: 'https://compute.cookie.autocut.io/main.cjs',
    expectedResponse: {
      status: 200,
    },
  },
} as const;
